import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./context/authContext";
import SessionExpiredOverlay from "./components/SessionExpired/SessionExpiredOverlay";

const ProtectedRoute = ({
    children,
    allowedRoles = [],
    requireAuth = true
}) => {
    const { isAuthenticated, user, loading } = useAuth();

    // Show loading while checking authentication
    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '50vh',
                fontSize: '16px'
            }}>
                Verifying access...
            </div>
        );
    }

    // Check authentication first
    if (requireAuth && !isAuthenticated) {
        console.log("User not authenticated, redirecting to login");
        return <Navigate to="/login" replace />;
    }

    // Check role-based access if roles are specified
    if (allowedRoles.length > 0) {
        if (!user || !allowedRoles.includes(user.user_role)) {
            console.log(`Access denied: User role '${user?.user_role}' not in allowed roles:`, allowedRoles);

            return <Navigate to="/" replace />;
        }
    }

    // Only render overlay for protected pages
    if (children) {
        return <>
            <SessionExpiredOverlay />
            {children}
        </>;
    }
    return <>
        <SessionExpiredOverlay />
        <Outlet />
    </>;
};

export default ProtectedRoute;
